import { SET_ENV } from '../../constant';

const setEnv = (env) => ({
  type: SET_ENV,
  env: env,
});

export { setEnv };
